export default __webpack_public_path__ + "static/media/S.022ede43.svg";